// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2UeXL","empty":"ModalGraph_empty__3LxxY"};